import { render, staticRenderFns } from "./AutomationFooter.vue?vue&type=template&id=51184587"
import script from "./AutomationFooter.vue?vue&type=script&lang=js"
export * from "./AutomationFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports